// Vuetify primero: nuestras hojas deben poder corregirlo en desarrollo.
// En producción no basta con el orden (ver assets/components.css).
import 'vuetify/styles'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { setVuetifyLocale, vuetify } from '@/plugins/vuetify'

import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import { useSnackbarStore } from './stores/snackbar'
import { setAuthErrorHandler, setNetworkErrorHandler } from './utils/api'
import { loadAnalytics, COOKIE_CONSENT_KEY } from '@/plugins/analytics'
import { i18n } from '@/i18n'
import { normalizeLocale } from '@/i18n'

const pinia = createPinia()

// Importante: el router puede disparar la navegación inicial al instalarse en la app.
// Inicializamos Analytics antes de .use(router) para no perder el primer page_view.
// En desarrollo: cargar GA si hay ID (para probar sin tener que aceptar cookies).
// En producción: solo si el usuario aceptó cookies.
const hasConsent =
  typeof localStorage !== 'undefined' && localStorage.getItem(COOKIE_CONSENT_KEY) === 'accepted'
const shouldLoadAnalytics =
  hasConsent || (import.meta.env.DEV && import.meta.env.VITE_GA_MEASUREMENT_ID)
if (shouldLoadAnalytics) {
  loadAnalytics()
}

const app = createApp(App)
  .use(pinia)
  .use(i18n)
  .use(vuetify)
  .use(router)

const authStore = useAuthStore(pinia)
const snackbarStore = useSnackbarStore(pinia)

try {
  const initialLocale = normalizeLocale(authStore.getPreferredLocale?.() || localStorage.getItem('app_locale'))
  i18n.global.locale.value = initialLocale
  setVuetifyLocale(initialLocale)
} catch {}
setAuthErrorHandler(() => {
  authStore.clearSession()
})
setNetworkErrorHandler(() => {
  snackbarStore.error(i18n.global.t('common.no_connection'))
})

;(async () => {
  try {
    const params = new URLSearchParams(window.location.search)
    const socialLogin = params.get('social_login')
    const errorParam = params.get('error')

    if (socialLogin === '1') {
      await authStore.fetchUserFromApi()
      const url = new URL(window.location.href)
      url.searchParams.delete('social_login')
      window.history.replaceState({}, '', url.pathname + url.search)
    }
    if (errorParam) {
      snackbarStore.error(decodeURIComponent(errorParam))
      const url = new URL(window.location.href)
      url.searchParams.delete('error')
      window.history.replaceState({}, '', url.pathname + url.search)
    }

    await authStore.checkSession()
  } catch (error) {
    console.error('Error al verificar sesión inicial:', error)
  }
  app.mount('#app')
})()
